<template>
    <div class="container pt-3">

        <div v-if="marcacao">
        
            <div v-if="marcacao.id_marcacao">
                <div class="display-4">
                    Marcação Realizada
                </div>
                <small>Id: {{ marcacao.id_marcacao }}</small>
                <hr>
            </div>

            <div v-if="marcacao.paciente">

                <form @submit.prevent="validar()" id="cad_paciente" ref="cad_paciente">

                    <!-- Dados da Operadora -->
                    <AzSubTitle title="Operadora / Plano"></AzSubTitle>

                    <!-- optionsData="id_plano" -->
                    <div class="row">
                        <div class="col col-12" :class="fl_particular ? 'col-md-9' : 'col-md-5'">
                            <AzInput :edicao="edicao" 
                                label="Operadora / Plano" 
                                type="select" 
                                optionsMode="aql" 
                                service="planos.index" 
                                optionsDisplay="search"
                                :optionsSync="false"
                                v-model="marcacao.paciente.paciente_unidade.plano"
                                required 
                                :validate="validate"/>
                        </div>
                        <div class="col col-12 col-md-3" v-if="!fl_particular">
                            <AzInput :edicao="edicao" label="Número da Matrícula" 
                                type="text" v-model="marcacao.paciente.paciente_unidade.st_numero_carteira"
                                :required="!fl_particular" :validate="validate"/>
                        </div>
                        <div class="col col-12 col-md-2" v-if="!fl_particular">
                            <AzInput :edicao="edicao" label="Vencimento da Matrícula" 
                                type="date"
                                v-model="marcacao.paciente.paciente_unidade.dt_validade_carteira" 
                                :rules="['futuro']"
                                :required="!fl_particular" :validate="validate"/>
                        </div>
                        <div class="col col-12" :class="fl_particular ? 'col-md-3' : 'col-md-2'">
                            <AzInput :edicao="edicao" label="Cartão SUS"
                                type="cns" v-model="marcacao.paciente.paciente_unidade.st_sus" :validate="validate"
                                :rules="['size:15']"/>
                        </div>
                    </div>
                        
                    <!-- Dados Pessoais -->
                    <AzSubTitle title="Dados Pessoais"></AzSubTitle>

                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input 
                                :edicao="edicao" 
                                label="Nome" 
                                type="text" 
                                v-model="marcacao.paciente.st_nome" 
                                required 
                                :validate="validate" 
                                :rules="['nome']" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input
                                :edicao="false" 
                                label="e-mail" 
                                type="email" 
                                v-model="marcacao.paciente.cadastro.st_email" 
                                :validate="validate" />
                        </div>
                    </div>

                    <div class="row">

                        <div class="col col-12 col-md-6">

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <AzInput :edicao="edicao" label="Sexo" 
                                        type="sexo" v-model="marcacao.paciente.cadastro.ch_sexo" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <AzInput :edicao="edicao" label="Data de Nascimento" 
                                        type="date" v-model="marcacao.paciente.cadastro.dt_nascimento"
                                        :validate="validate" :rules="['nasc']" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <AzInput :edicao="edicao" label="CPF" 
                                        type="cpf" v-model="marcacao.paciente.cadastro.st_cpf" 
                                        required 
                                        :validate="validate" :rules="['cpf']"
                                        />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <AzInput :edicao="edicao" label="RG" 
                                        type="text" v-model="marcacao.paciente.cadastro.st_rg" 
                                        :validate="validate" :rules="['rg']" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-6">
                                    <AzInput :edicao="edicao" label="Nome da Mãe" 
                                        type="text" v-model="marcacao.paciente.cadastro.st_nome_mae" 
                                        :validate="validate" :rules="['nome']" />
                                </div>
                                <div class="col col-6">
                                    <AzInput :edicao="edicao" label="Nome Social" 
                                        type="text" v-model="marcacao.paciente.st_nome_social" 
                                        :validate="validate" :rules="['nome']" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <div v-if="marcacao.paciente.cadastro.telefones">
                                        <az-input label="Telefone"
                                            type="fone" v-model="marcacao.paciente.cadastro.telefones.telefone" 
                                            required :edicao="edicao" :validate="validate"  />
                                    </div>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <div v-if="marcacao.paciente.cadastro.telefones">
                                        <az-input label="Celular" type="fone" 
                                            v-model="marcacao.paciente.cadastro.telefones.celular" 
                                            :edicao="edicao" :validate="validate" />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col col-12 col-md-6">
                            <cadastro-endereco :edicao="edicao" v-model="marcacao.paciente.cadastro.endereco" :validate="validate" />
                        </div>

                    </div>

                    
                </form>

            </div>
            <div v-else>

                <div class="row">
                    <div class="col col-12 col-md-8">
                        <az-input
                            label="Procedimento"
                            :edicao="false"
                            v-model="marcacao.procedimento.search" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Profissional"
                            :edicao="false"
                            v-model="marcacao.medico.search" />
                    </div>
                </div>

                <div class="alert alert-light text-center mt-3">
                    <h4>
                        {{ $util.getFormatDate(marcacao.dt_inicio) }}
                        {{ marcacao.dt_inicio.substr(11,5) }}
                    </h4>
                    <h5>
                        {{ $util.getFormatDate(marcacao.dt_inicio, 'dddd') }}
                    </h5>
                    <h5> 
                        {{ tempoQueFalta () }}
                    </h5>
                </div>

                <az-sub-title class="mt-3" title="Dados Pessoais" :big="true" />
                <div class="row">
                    <div class="col col-12">
                        <az-input
                            label="Nome"
                            v-model="marcacao.cadastro_temporario.st_nome" />
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Sexo"
                            type="sexo"
                            v-model="marcacao.cadastro_temporario.ch_sexo" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Data de Nascimento"
                            type="date"
                            v-model="marcacao.cadastro_temporario.dt_nascimento" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Idade"
                            :edicao="false"
                            v-model="marcacao.cadastro_temporario.idade" />
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Telefone"
                            type="fone"
                            v-model="marcacao.cadastro_temporario.st_telefone" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            label="Celular"
                            type="fone"
                            v-model="marcacao.cadastro_temporario.st_celular" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input
                            label="e-mail"
                            :edicao="false"
                            v-model="marcacao.cadastro_temporario.st_email" />
                    </div>
                </div>

                <div v-if="marcacao.plano.id_operadora != 1">
                    <az-sub-title class="mt-3" title="Dados da Operadora" :big="true" />
                    <div class="row">
                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Operadora / Plano"
                                :edicao="false"
                                v-model="marcacao.plano.search" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Número da Carteira" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Validade da Carteira" />
                        </div>
                    </div>
                </div>

                <az-sub-title class="mt-3" title="Endereço" :big="true" />
                <div class="row">
                    <div class="col col-8">
                        <cadastro-endereco v-model="endereco" />
                    </div>
                </div>
                
            </div>

            <div class="d-flex flex-column mt-3">
                <button type="button" class="btn btn-success">
                    Atualizar Cadastro
                </button>
            </div>

            <br><br>

            <!--
                v-on:payment-authorized="paymentAuthorized"
                v-on:payment-completed="paymentCompleted"
                v-on:payment-cancelled="paymentCancelled"
            -->
            
        </div>

        <div v-else> 
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import * as moment from 'moment';

export default {
    data () { 
        return {
            marcacao: null,
            endereco: { 
                id_estado: null, 
                cidade: null,  
            }, 
            fl_particular: true, 
            validate: false, 
            edicao: true, 

            myStyle: {
                label: 'pay',
                size:  'responsive',
                shape: 'rect',
                color: 'blue'
            },
            credentials: { 
                sandbox: '',
                
            },
            experience: {
                input_fields: {
                    no_shipping: 1,
                },
            },

            publishableKey: '',
            items: [
                {
                    sku: '', 
                    quantity: 1
                }
            ],
            successUrl: 'http://www.globo.com/',
            cancelUrl: 'http://www.uol.com.br/',
        }
    },

    components: { 
        AzInput,
        AzSubTitle, 
        CadastroEndereco,
    },

    props: [ 'id', 'token' ],

    methods: { 
        checkout () {
            this.$refs.checkoutRef.redirectToCheckout();
        },

        submit () {
            this.$refs.elementsRef.submit();
        },

        tempoQueFalta () { 
            let end = moment().startOf('day');
            return moment.duration(moment(this.marcacao.dt_inicio, 'YYYY-MM-DD').diff(end)).humanize(true);
        }
    },

    mounted () { 

        if ( this.id ) { 

            let parms = { 
                id: this.id,
                token: this.token,
                model: 'marcacao'
            }

            this.axios.post('/paciente/confirmar', parms)
                .then(res => { 
                    this.marcacao = res.data;
                });

        } else { 

            this.$util.loadItem(this, { 
                service: 'pacientes', 
                id: this.$store.state.user.id_pessoa,
            })
            .then(res => { 

                this.marcacao = { 
                    id_marcacao: null, 
                    paciente: { ...res }, 
                };

                if ( !this.marcacao.paciente.paciente_unidade ) { 
                    this.marcacao.paciente.paciente_unidade = {};
                }

                if ( !this.marcacao.paciente.cadastro ) { 
                    this.marcacao.paciente.cadastro = {
                        st_email: this.$store.state.user.st_login, 
                        endereco: {},
                        telefones: {}
                    };
                }

            });


        }

    }
}
</script>